import { Base } from "../../framework/base";
import { InstantMessageChannelInvitation } from "./instantMessageChannelInvitation";
import { InstantMessageListItem } from "./instantMessageListItem";
var InstantMessageChannelItem = /** @class */ (function () {
    function InstantMessageChannelItem(obj) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.picture = obj && obj.picture || "";
        this.comment = obj && obj.comment || "";
        this.active = obj && obj.active || false;
        this.rowId = obj && obj.rowId || "";
        this.userIsAdmin = obj && obj.userIsAdmin || false;
        this.userIsOnlyAdmin = obj && obj.userIsOnlyAdmin || false;
        this.isGroup = obj && obj.isGroup || false;
        this.otherUserCode = obj && obj.otherUserCode || "";
        this.hasUnreadMessages = obj && obj.hasUnreadMessages || false;
        this.latestMessage = (obj === null || obj === void 0 ? void 0 : obj.latestMessage) ? new InstantMessageListItem(obj.latestMessage) : null;
        this.invitation = (obj === null || obj === void 0 ? void 0 : obj.invitation) ? new InstantMessageChannelInvitation(obj.invitation) : null;
    }
    InstantMessageChannelItem.prototype.getHash = function () {
        return this.id + "#" + this.rowId + "#" + (this.latestMessage ? this.latestMessage.getHash() : "") + "#" + (this.invitation ? this.invitation.getHash() : "") + "#" + (this.hasUnreadMessages ? "1" : "0");
    };
    InstantMessageChannelItem.prototype.getPicture = function () {
        if (this.picture) {
            return this.picture;
        }
        return "";
    };
    ;
    InstantMessageChannelItem.prototype.getPictureClass = function () {
        if (this.getPicture()) {
            return "";
        }
        else {
            return this.isGroup ? "icon instantMessageGroup" : "";
        }
    };
    ;
    InstantMessageChannelItem.prototype.getLatestMessageDate = function () {
        if (this.invitation) {
            return this.invitation.sender.date;
        }
        if (this.latestMessage) {
            return this.latestMessage.modifyUser.date;
        }
        return 0;
    };
    InstantMessageChannelItem.getHash = function (items) {
        if (!items && items.length < 1)
            return "";
        return items.map(function (i) { return i.getHash(); }).join(",");
    };
    InstantMessageChannelItem.sortInstantMessageListItems = function (items) {
        if (!items && items.length < 2)
            return items;
        return items.sort(function (a, b) {
            if (!a || !b)
                return 0;
            var result = Base.numCompare(a.active ? 0 : 1, b.active ? 0 : 1);
            if (result !== 0)
                return result;
            result = -1 * Base.numCompare(a.getLatestMessageDate(), b.getLatestMessageDate());
            if (result !== 0)
                return result;
            return Base.strCompare(a.code, b.code);
        });
    };
    return InstantMessageChannelItem;
}());
export { InstantMessageChannelItem };
